import 'rsuite/dist/rsuite-no-reset.min.css'; 
import './src/styles/_variables.scss';
export const onClientEntry = () => {
  document.documentElement.setAttribute("lang", "en");
};
